// Import model
import { FilterFcb2BUnderlaymentOptionRequest } from '../models/FilterFcb2BUnderlaymentOptionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Fcb2BUnderlaymentOptionCondition } from '../models/Fcb2BUnderlaymentOptionCondition';
import { Fcb2BUnderlaymentOptionFields } from '../models/Fcb2BUnderlaymentOptionFields';
import { Fcb2BUnderlaymentOptionIndexedFields } from '../models/Fcb2BUnderlaymentOptionIndexedFields';

// Import dependency serializers (for complex types)
import { Fcb2BUnderlaymentOptionConditionSerializer } from './Fcb2BUnderlaymentOptionConditionSerializer';
import { Fcb2BUnderlaymentOptionFieldsSerializer } from './Fcb2BUnderlaymentOptionFieldsSerializer';
import { Fcb2BUnderlaymentOptionIndexedFieldsSerializer } from './Fcb2BUnderlaymentOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterFcb2BUnderlaymentOptionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterFcb2BUnderlaymentOptionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterFcb2BUnderlaymentOptionRequest instance
   */
  static deserialize(json: string): FilterFcb2BUnderlaymentOptionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterFcb2BUnderlaymentOptionRequest instance
   */
  static fromObject(obj: any): FilterFcb2BUnderlaymentOptionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterFcb2BUnderlaymentOptionRequest');
    }


    const instance: FilterFcb2BUnderlaymentOptionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as Fcb2BUnderlaymentOptionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as Fcb2BUnderlaymentOptionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        Fcb2BUnderlaymentOptionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterFcb2BUnderlaymentOptionRequest instances
   */
  static deserializeArray(json: string): FilterFcb2BUnderlaymentOptionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterFcb2BUnderlaymentOptionRequest instance to a JSON string
   */
  static serialize(instance: FilterFcb2BUnderlaymentOptionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterFcb2BUnderlaymentOptionRequest instance to a plain object
   */
  static toObject(instance: FilterFcb2BUnderlaymentOptionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        Fcb2BUnderlaymentOptionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterFcb2BUnderlaymentOptionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterFcb2BUnderlaymentOptionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
